import { createSlotRecipe } from './runtime';

const formFieldConfig = {"name":"formField","slots":["fieldWrapper","label","inputBox","input","error"],"variantMap":{"variant":["inline","card"],"override":["textarea"]}}

export const formField = /* @__PURE__ */ createSlotRecipe(formFieldConfig)